import { render, staticRenderFns } from "./VideoReviews.vue?vue&type=template&id=61094644&scoped=true&"
import script from "./VideoReviews.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoReviews.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoReviews.vue?vue&type=style&index=0&id=61094644&scoped=true&lang=scss&"
import style1 from "./VideoReviews.vue?vue&type=style&index=1&id=61094644&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61094644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61094644')) {
      api.createRecord('61094644', component.options)
    } else {
      api.reload('61094644', component.options)
    }
    module.hot.accept("./VideoReviews.vue?vue&type=template&id=61094644&scoped=true&", function () {
      api.rerender('61094644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/VideoReviews.vue"
export default component.exports